import React, { useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Card,
  TextField,
  Button,
  Alert,
  Snackbar,
  Slide,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import axios from "axios";
import { SpaceDashboard, Save } from "@mui/icons-material";

import { cardBodyStyle } from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ConfigClientAdmin(props) {
  const classes = useStyles();

  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [mensageSystem, setMensageSystem] = React.useState("");
  const [disabled, setDisabled] = React.useState(true);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const [values, setValues] = React.useState({
    ivaPercentage: "",
    servicePercentage: "",
    tourismPercentage: "",
  });

  const { urlServices, UserAuth } = React.useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchData();
  }, []);

  const fetchData = async () => {
    setOpenLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}clients/${UserAuth.clients_id}`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      const transformed = {
        ...response.data.data,
        config: response.data.data.config
          ? JSON.parse(response.data.data.config)
          : null,
      };

      setValues({
        ...values,
        ivaPercentage: transformed.config?.ivaPercentage,
        servicePercentage: transformed.config?.servicePercentage,
        tourismPercentage: transformed.config?.tourismPercentage,
      });
      setOpenLoader(false);
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      setOpenLoader(true);
      setDisabled(true);

      const dataValue = {
        config: JSON.stringify({
          ivaPercentage: values.ivaPercentage,
          servicePercentage: values.servicePercentage,
          tourismPercentage: values.tourismPercentage,
        }),
      };

      const response = await axios.put(
        `${urlServices}clients/${UserAuth.clients_id}`,
        dataValue,
        {
          headers: { Authorization: "Bearer " + keyAuthorization },
        }
      );
      if (response.status === 200) {
        setAlert({
          openAlert: true,
          errorAlert: "success",
          mensaje: "Registro guardado con exito.",
        });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setOpenLoader(false);
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
    });
    setAlert({
      openAlert: false,
    });
    setDisabled(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      openAlert: false,
    });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={8} md={8}>
        {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
        <div className={classes.cardTitleBlack}>
          <SpaceDashboard className={classes.iconFilter} /> Configuración
        </div>
      </Grid>
      <Grid item xs={12} sm={4} md={4}>
        <Button
          variant="contained"
          color="success"
          sx={{ float: "right" }}
          startIcon={<Save />}
          disabled={disabled}
          onClick={submitForm}
        >
          Guardar todos los cambios
        </Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Card
          sx={{ padding: "15px 20px", margin: "10px 0" }}
          variant="outlined"
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              sx={{ background: "#f6f6f6", p: 1, m: 2 }}
            >
              <b className={classes.cardTitleBlack} style={{ fontSize: 18 }}>
                Pocentajes en precios %
              </b>
              <Alert severity="info">
                Valores adicionales que se aplicarán al precio fijo de las
                unidades.
              </Alert>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <b
                className={classes.cardTitleBlack}
                style={{ fontSize: 14, fontWeight: 500 }}
              >
                Porcentaje IVA %
              </b>
              <TextField
                // label="IVA %"
                variant="outlined"
                value={values.ivaPercentage}
                onChange={handleChange("ivaPercentage")}
                type="number"
                inputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                autoComplete="off"
                margin="dense"
                fullWidth
                placeholder="Ingresar..."
                helperText="Aplica solo a clientes de Ecuador."
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <b
                className={classes.cardTitleBlack}
                style={{ fontSize: 14, fontWeight: 500 }}
              >
                Porcentaje en servicio %
              </b>
              <TextField
                // label="IVA %"
                variant="outlined"
                value={values.servicePercentage}
                onChange={handleChange("servicePercentage")}
                type="number"
                inputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                autoComplete="off"
                margin="dense"
                fullWidth
                placeholder="Ingresar..."
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <b
                className={classes.cardTitleBlack}
                style={{ fontSize: 14, fontWeight: 500 }}
              >
                Porcentaje tasa de turismo %
              </b>
              <TextField
                // label="IVA %"
                variant="outlined"
                value={values.tourismPercentage}
                onChange={handleChange("tourismPercentage")}
                type="number"
                inputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                autoComplete="off"
                margin="dense"
                fullWidth
                placeholder="Ingresar..."
                helperText="Por noche."
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alert.openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={alert.openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity={alert.errorAlert === "error" ? "error" : "success"}
            elevation={6}
            variant="filled"
          >
            {alert.mensaje}
          </Alert>
        </Slide>
      </Snackbar>
    </Grid>
  );
}
